<template>
  <div>
    <navbar class="navbar" />
    <v-card outlined >
      <v-card-text>
        <v-row><v-col><h3>สินค้า</h3></v-col></v-row>

        <v-row>
          <v-divider></v-divider>
        </v-row>

        <search />
        <v-divider class="mt-3 mb-5"></v-divider>

        <v-row>
          <v-col
            xs="12"
            sm="12"
            md="6"
            lg="2"
            cols="12"
            v-if="canCreate"
          >
            <router-link :to="{ name: 'ProductCreate' }" tag="span">
              <v-btn
                color="primary"
                width="100%"
                class="pa-5"
                depressed
              >
                <v-icon class="mr-5">mdi-plus</v-icon>
                เพิ่มสินค้า
              </v-btn>
            </router-link>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-data-table
              :headers="headers"
              :items="itemsTableData"
              item-key="_id"
            >

              <template v-slot:item.image="{item}">
                <v-img
                  :src="item.image"
                  width="60px"
                  class="mt-2 mb-2 mr-auto ml-auto"
                />
              </template>
              <template v-slot:item.categoryName="{item}">
                {{ item.categoryID.name }}
              </template>
              <template v-slot:item.action="{item}">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      small
                      v-bind="attrs"
                      v-on="on"
                      class="view-item mr-2"
                      @click="viewItem(item)"
                      v-if="canView"
                    >
                      mdi-file-eye
                    </v-icon>
                  </template>
                  <span>ดูรายละเอียดสินค้า</span>
                </v-tooltip>

                <v-tooltip
                  bottom
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      small
                      v-bind="attrs"
                      v-on="on"
                      class="edit-item mr-2"
                      @click="editItem(item)"
                      v-if="canUpdate"
                    >
                      mdi-file-document-edit-outline
                    </v-icon>
                  </template>
                  <span>แก้ไขรายละเอียดสินค้า</span>
                </v-tooltip>

                <v-tooltip
                  bottom
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      small
                      v-bind="attrs"
                      v-on="on"
                      class="delete-item mr-2"
                      @click="deleteItem(item)"
                      v-if="canUpdate"
                    >
                      mdi-trash-can-outline
                    </v-icon>
                  </template>
                  <span>ลบสินค้า</span>
                </v-tooltip>

              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

      <v-dialog v-model="dialogDelete" persistent max-width="290">
        <v-card outlined >
          <v-card-title>ต้องการลบ ?</v-card-title>
          <v-card-text>การลบไม่สามารถกู้คืนได้ กรุณาทบทวน</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="dialogDelete = false">ยกเลิก</v-btn>
            <v-btn
              color="error"
              text
              @click="confirmDelete()"
            >ยืนยัน</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

  </div>
</template>
<script>
import script from '@/views/pages/products/product/index.script';

export default script;
</script>
